import axios from 'axios';
import { Connector, Entity, EntityMap } from './types';
import { useQuery } from 'react-query';
import { AFAS_CONNECTORS, AFAS_IMPORT_MAPPING } from 'RestAPIs/endpoints';

export const useGetAFASImportMappings = () => {
  const getAFASImportMappings = () =>
    axios.get<EntityMap[]>(AFAS_IMPORT_MAPPING);

  const { data, isFetching } = useQuery(['entity-mappings'], async () => {
    const { data } = await getAFASImportMappings();

    return data;
  });

  return { data, isFetchingAFASImportMappings: isFetching };
};

export const getPropertyMappings = (id: number) =>
  axios.get<Entity>(`${AFAS_IMPORT_MAPPING}/${id}`);

export const useGetAFASConnections = () => {
  const getConnectors = () => axios.get<Connector>(AFAS_CONNECTORS);

  const { data, isFetching } = useQuery(['connectors-config'], async () => {
    const { data } = await getConnectors();

    return data;
  });

  return { AFASConnectors: data, isFetchingAFASConnections: isFetching };
};
